import { css } from '@emotion/react';

import * as React from 'react';

import { MenuList } from '@coursera/cds-core';

type Props = {
  label: string;
  icon: React.ReactNode;
  isActive?: boolean;
  onClick: () => void;
};

const styles = css`
  color: var(--cds-color-interactive-primary-selected);
`;

class NavItem extends React.Component<Props> {
  render() {
    const { label, icon, isActive, onClick } = this.props;
    return (
      <MenuList.ItemLink
        onClick={onClick}
        prefix={icon}
        aria-current={isActive ? 'page' : undefined}
        css={isActive ? styles : undefined}
      >
        {label}
      </MenuList.ItemLink>
    );
  }
}

export default NavItem;
